<template>
  <v-card class="docs serviceCZN">
    <v-card-title>
      <div class="text-h5 text-center">Создание карточки сервиса</div>
    </v-card-title>

    <table class="docs-table">
      <tbody>
      <tr>
        <td>
          Наименование сервиса
        </td>
        <td>
          <div class="standard-docs-params">
            <div>
              <div class="control">
                <input type="text" placeholder=" " v-model="serviceName">
                <label>Наименование сервиса</label>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Категория сервиса
        </td>
        <td>
          <v-autocomplete
              dense
              :items="categories"
              v-model="serviceCategory"
              label="Категория сервиса"
          ></v-autocomplete>
        </td>
      </tr>
      </tbody>
    </table>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          class="btn btn-outline"
          text
          @click="$emit('close')"
      >
        Отмена
      </v-btn>
      <v-btn
          class="btn btn-primary"
          @click="submit()"
      >
        Создать
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {categories, saveServices} from "@/modules/services";

export default {
  name: 'NewDialog',
  props: ['services'],
  data: () => ({
    serviceName: '',
    serviceCategory: '',
    categories: categories,
  }),
  methods: {
    async submit(){
      this.services.push({
        'id': crypto.randomUUID(),
        'category': this.serviceCategory,
        'name': this.serviceName
      })
      await saveServices(this.services)
      this.$emit('close')
    }
  }
}
</script>


